module.exports = __webpack_public_path__ + "../resources/img/ic_fold_right.def5b1ee.svg";